import $ from 'jquery';
$('#play-pause-button').click(function () {
    let mediaVideo = $('#media-video').get(0);
    if (mediaVideo.paused) {
        mediaVideo.play();
        $('.play').hide();
        $('.pause').show();
        $(this).attr('aria-label', 'Pause');
    }
    else {
        mediaVideo.pause();
        $('.play').show();
        $('.pause').hide();
        $(this).attr('aria-label', 'Play');
    }
});
